module.exports = __webpack_public_path__ + "static/img/jifenguiji.696c828a.jpg";